module.exports = __webpack_public_path__ + "img/img_db_dt_btm.91a0d7da.png";